// extracted by mini-css-extract-plugin
export default {"root":"TitleRow-module--root--98998"};